export const SdxAdminSubject = {
  Batch: 'Batch',
  Catalog: 'Catalog',
  Excel: 'Excel',
  FinancialData: 'FinancialData',
  Product: 'Product',
  Taxon: 'Taxon',
  TopSwap: 'TopSwap',
};
